import { AuthProvider } from '@/auth/application/AuthContext';
import NavigationScroll from '@/common/presentation/components/layout/NavigationScroll';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { RouterProvider } from 'react-router-dom';
import router from '@/common/main/routes';
import { useOnlineStatus } from '@/common/application/hooks/useOnlineStatus';
import Offline from './components/Offline/Offline';
import { GpsSignalRProvider } from './components/GpsSignalRProvider';
import { UmNotificationsRealtimeProvider } from '@/userManagement/presentation/providers/UmNotificationsRealtimeProvider';
import { useEffect } from 'react';
import { useEmbeddedModeStore } from '@/store/EmbeddedModeStore';

const App = () => {
  const isOnline = useOnlineStatus();

  // TROC-317: sync ERP embed chrome-hide before routes (login sits outside Layout).
  useEffect(() => {
    useEmbeddedModeStore.getState().syncFromSearch(window.location.search);
  }, []);

  if (!isOnline) return <Offline />;

  return (
    <NavigationScroll>
      <AuthProvider>
        <GpsSignalRProvider>
          <UmNotificationsRealtimeProvider>
            <PerfectScrollbar style={{ height: '100vh' }}>
              <NuqsAdapter>
                <RouterProvider router={router} />
              </NuqsAdapter>
            </PerfectScrollbar>
          </UmNotificationsRealtimeProvider>
        </GpsSignalRProvider>
      </AuthProvider>
    </NavigationScroll>
  );
};

export default App;
